import React from 'react'
import classNames from 'classnames';

export default function Banner({header, body, className, onClose}) {
  function bannerClassNames() {
    return classNames(
      'ds-banner',
      className,
    );
  }

  return (
    <div className={bannerClassNames()}>
      <p className="subhead _fontSize--large -white"> {header} </p>
      <p className="copy"> {body} </p>

      { !!onClose &&
        <a className="dismiss" role="button" onClick={onClose}>
          <i className="materialIcon --micro -inverted"> close </i>
        </a>
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/Banner.js